import { InjectionToken } from '@angular/core';
import { IStorageService } from './storage.model';
import { localStorageFactory } from './storage.resolver';

export const LOCAL_STORAGE = new InjectionToken<IStorageService>('LOCAL_STORAGE', {
    factory: localStorageFactory
});
